import { enqueueSnackbar } from 'actions';

import {
	GetIncidentConfigurationsRequest,
	DeleteIncidentConfigurationRequest,
	AddIncidentConfigurationRequest,
	UpdateIncidentConfigurationRequest,
	IsSafeToDeleteConfigurationRequest
} from '../requests/IncidentTrackerConfigurationRequests.js';

export const GET_INCIDENT_CONFIGURATIONS = 'GET_INCIDENT_CONFIGURATIONS';
export const TOGGLE_INC_CONFIG_DIALOG = 'TOGGLE_INC_CONFIG_DIALOG';
export const SELECT_INC_CONFIGURATION = 'SELECT_INC_CONFIGURATION';
export const SET_FORM_STATE = 'SET_FORM_STATE';

const onGetIncidentConfigurations = (value) => ({
	type: GET_INCIDENT_CONFIGURATIONS,
	incidentConfigurations: value
});

const onSelectIncidentConfiguration = (config) => ({
	type: SELECT_INC_CONFIGURATION,
	selectedConfiguration: config
});

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

export const GetIncidentConfigurations = () => async (dispatch) => {
	await GetIncidentConfigurationsRequest().then(response => {
		dispatch(onGetIncidentConfigurations(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const SelectIncidentConfiguration = (config) => (dispatch) => {
	dispatch(onSelectIncidentConfiguration(config));
};

const onToggleIncConfigDialog = (visible, mode) => ({
	type: TOGGLE_INC_CONFIG_DIALOG,
	visible,
	mode
});

export const ToggleIncConfigDialog = (visible, mode) => (dispatch) => {
	dispatch(onToggleIncConfigDialog(visible, mode));
};

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

export const DeleteIncidentConfiguration = (configurationName, id) => async (dispatch) => {
	await IsSafeToDeleteConfigurationRequest(configurationName, id).then(async isSafe => {
		await DeleteIncidentConfigurationRequest(configurationName, id).then(response => {
			dispatch(enqueueSnackbar({ message: 'Incident configuration successfully deleted.', options: { variant: 'success' } }));
			dispatch(GetIncidentConfigurations());
		}).catch((error) => {
			if (error) {
				dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
			}
		});
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const AddIncidentConfiguration = (item) => async (dispatch) => {
	await AddIncidentConfigurationRequest(item).then(response => {
		dispatch(enqueueSnackbar({ message: 'Incident configuration successfully added.', options: { variant: 'success' } }));
		dispatch(GetIncidentConfigurations());
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const UpdateIncidentConfiguration = (item) => async (dispatch) => {
	await UpdateIncidentConfigurationRequest(item).then(response => {
		dispatch(enqueueSnackbar({ message: 'Incident configuration successfully updated.', options: { variant: 'success' } }));
		dispatch(GetIncidentConfigurations());
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
